import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {EmployeeDTO} from "../domain/dtos/employee.dto";
import {Employee} from "../domain/entities/employee.entity";
import {ObjectHelper} from "../helpers/object.helper";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@transformer({
    source: Employee,
    target: `dto`
})
export class EmployeeToDtoTransformer implements TransformerInterface<Partial<EmployeeDTO>, Employee> {

    public transform(employee: Employee): Promise<Partial<EmployeeDTO>> {

        const dto: Partial<EmployeeDTO> = employee.isNew()
            ? {
                uid: employee.uid,
                firstName: employee.firstName,
                lastName: employee.lastName,
                shortcut: employee.shortcut,
                color: employee.color,
                createdAt: employee.createdAt.toUTC().toSQL() ?? undefined,
                sorting: -1,
            }
            : Object.fromEntries(
                employee.changedValues.map(propertyName => [propertyName, ObjectHelper.getPropertyValue(employee, propertyName)!])
            );

        dto.uid = employee.uid;

        return Promise.resolve(dto);
    }

}
